// Toyo Blitz configuration
import { AppConfig } from './types';
import { blitzTheme } from './themes';
import { BLITZ_GAMES } from './games';

export const blitzConfig: AppConfig = {
  // App identity
  appId: 'blitz',
  appName: 'Toyo Blitz',
  appTagline: 'Fast. Fierce. Fun.',
  
  // Branding
  logo: '/assets/toyo-blitz-logo.png',
  homeUrl: 'https://toyo.games/toyo-blitz',
  
  // Theme
  theme: blitzTheme,
  
  // Games - Blitz only has competitive games
  games: BLITZ_GAMES,
  
  // Feature flags
  features: {
    voting: true,
    hostPlaying: true,
    settings: true,
  },
  
  // Storage prefix
  storagePrefix: 'toyo-blitz',
  
  // SEO and metadata
  seo: {
    title: 'Toyo Blitz - Fast-Paced Competitive Trivia Games | blitz.toyo.games',
    description: 'Play fast-paced competitive trivia games with Toyo Blitz. Speed Challenge, Trivia, Word Puzzles, Picture Perfect, Close or Not, and Fact or Myth. Perfect for parties, team building, and social gatherings. Join rooms instantly and compete in real-time!',
    keywords: [
      'toyo blitz',
      'blitz games',
      'competitive trivia',
      'speed challenge',
      'trivia games',
      'word puzzles',
      'picture perfect',
      'close or not',
      'fact or myth',
      'party games',
      'team building games',
      'real-time multiplayer',
      'mobile games',
      'social games',
      'fast-paced games',
      'trivia quiz',
      'online games',
      'multiplayer trivia',
    ],
    ogTitle: 'Toyo Blitz - Fast. Fierce. Fun.',
    ogDescription: 'Fast-paced competitive trivia games. Speed Challenge, Trivia, Word Puzzles, and more. Perfect for parties and team building!',
    ogImage: '/assets/toyo-blitz-logo.png',
    ogUrl: 'https://blitz.toyo.games',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Toyo Blitz - Fast. Fierce. Fun.',
    twitterDescription: 'Fast-paced competitive trivia games. Perfect for parties and team building!',
    twitterImage: '/assets/toyo-blitz-logo.png',
  },
};

